export enum listOfRetailDistributors {
    CARREFOUR = 'Carrefour',
    AUCHAN = 'Auchan',
    INTERMARCHE = 'Intermarché',
    LECLERC = "Leclerc",
}
